import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TimeReportsEmptyState() {
    const { t } = useTranslation("project");

    return (
        <Alert severity="info" sx={{ gridColumn: "1/-1" }}>
            <Typography variant="body2" color="textSecondary">
                {t("projectReviewVisitV2.timeReportsRoute.noReportsFound")}
            </Typography>
        </Alert>
    );
}
